import { useContext } from "react";
import AuthContext from "../../context/AuthContext";

/** Gets the authentication context of the application. */
export const useAuth = () => {
  const authContext = useContext(AuthContext);
  return authContext;
};
